import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { UserService } from '../user/user.service';

@Injectable({
    providedIn: 'root'
})
export class InitialRedirectGuard implements CanActivate {

    constructor(
        private router: Router,
        private user: UserService
    ) { }

    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
        const currentPath = route.url.join('/');

        if (currentPath !== '') {
            return true;
        }
        if (this.user.hasCreditCardOnFile) {
            return this.router.createUrlTree(['/calls']);
        }
        return this.router.createUrlTree(['/setup']);
    }
}
